import {
  FC,
  useState,
  MutableRefObject,
  CSSProperties,
} from 'react';
// 组件
import { ProInput, ProModal, ProAlert } from '../../antd';
import { useLayoutContext } from '../../PageLayout/context/LayoutContext'
// 常量
import { ModalTableActionType } from '../../constants/interface';
import { downloadCsv } from '../../utils/dataUtils';

interface CopyPreviewModalProps {
  copyPreviewModalRef: MutableRefObject<ModalTableActionType>;
}

const textAreaStyle: CSSProperties = {
  cursor: 'default',
  backgroundColor: '#fff',
  color: '#333',
};
interface CopyPreviewData {
  /** 复制字符串 */
  copyText?: string;
  /** csv数据 */
  csvRows?: any[][];
  /** 行数 */
  rows?: number;
}
/** 复制预览 */
const CopyPreviewModal: FC<CopyPreviewModalProps> = props => {
  const { copyPreviewModalRef } = props;
  const { routes } = useLayoutContext();
  const [visible, setVisible] = useState<boolean>(false);
  const [data, setData] = useState<CopyPreviewData>();
  /** 取消 */
  const handleCancel = () => {
    setVisible(false);
  };
  /** 显示 */
  const handleShow = (newData: CopyPreviewData) => {
    setData(newData);
    setVisible(true);
  };
  /** 下载 */
  const handleDownload = () => {
    const csvData: string[] = [];
    data?.csvRows?.forEach?.(item => {
      csvData.push(item.join(','));
    });
    const _window = window.__POWERED_BY_WUJIE__ ? window.parent : window;
    const currentPathname = _window.location.pathname;
    const findItem = routes.find(item => item.path === currentPathname);
    downloadCsv(csvData.join('\n'), findItem?.name);
  };
  copyPreviewModalRef.current = {
    hide: handleCancel,
    show: handleShow,
  };
  return (
    <ProModal
      title="复制预览"
      open={visible}
      destroyOnClose
      maskClosable={false}
      onCancel={handleCancel}
      onOk={handleDownload}
      okText='下载'
      cancelText='关闭'
    >
      <ProAlert
        type="info"
        message="可将以下内容直接复制后粘贴到Excel中"
        style={{ marginBottom: 15 }}
      />
      <ProInput.TextArea
        id="text_area_copy_node"
        rows={(data?.rows && data?.rows > 8) ? data?.rows : 8}
        value={data?.copyText}
        disabled={true}
        style={textAreaStyle}
        autoSize={{ maxRows: 28, }}
      />
    </ProModal>
  );
};

export default CopyPreviewModal;
